// extracted by mini-css-extract-plugin
export default {"siteFooter":"siteFooter_siteFooter__6feG2","nav":"siteFooter_nav__RScAR","copyright":"siteFooter_copyright__QqmYT"};